export {default} from "./ratingSlider";
